import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '@deliveroo/consumer-component-library/components/Button';

import styles from './styles.scss';

class OrderHelpFeedbackText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitText: '',
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmitFeedback = this.onSubmitFeedback.bind(this);
  }

  onChange(event) {
    this.setState({
      submitText: event.target.value,
    });
  }

  onSubmitFeedback(event) {
    event.preventDefault();

    this.props.setFeedbackDescription(this.state.submitText, this.props.submitUrl);
  }

  render() {
    const { iframe, buttonText } = this.props;
    return (
      <form
        onSubmit={this.onSubmitFeedback}
        className={classnames(styles.feedbackTextForm, { [styles.modal]: iframe })}
      >
        <textarea className={styles.feedbackText} onChange={this.onChange} />
        <Button type="primary" isDisabled={this.state.submitText.length < 1} shouldSubmit>
          {buttonText}
        </Button>
      </form>
    );
  }
}

OrderHelpFeedbackText.propTypes = {
  iframe: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  setFeedbackDescription: PropTypes.func.isRequired,
  submitUrl: PropTypes.string,
};

OrderHelpFeedbackText.defaultProps = {
  iframe: false,
  submitUrl: null,
};

export default OrderHelpFeedbackText;
